import { useState } from "react";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { STATUS_CONFIG } from "./constants";

export function StatusChangeModal({ open, onClose, onSubmit, currentStatus, loading }) {
  const [novoStatus, setNovoStatus] = useState("");
  const [comentario, setComentario] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(novoStatus, comentario);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Alterar Status</DialogTitle>
          <DialogDescription>
            Status atual: <Badge className={STATUS_CONFIG[currentStatus]?.color}>{STATUS_CONFIG[currentStatus]?.label}</Badge>
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label>Novo Status *</Label>
            <Select value={novoStatus || "placeholder"} onValueChange={(v) => setNovoStatus(v === "placeholder" ? "" : v)}>
              <SelectTrigger>
                <SelectValue placeholder="Selecione..." />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="placeholder" disabled>Selecione...</SelectItem>
                {Object.entries(STATUS_CONFIG).map(([key, cfg]) => (
                  <SelectItem key={key} value={key} disabled={key === currentStatus}>
                    {cfg.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Comentario *</Label>
            <Textarea
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
              required
              rows={3}
              placeholder="Justifique a mudanca de status..."
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancelar</Button>
            <Button type="submit" disabled={loading || !novoStatus || !comentario}>
              {loading ? "Alterando..." : "Confirmar"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
